module.exports = __webpack_public_path__ + "static/media/no-data-show.73810b0f.png";